import PreferencesAlerts from './PreferencesAlerts.connect'

export default PreferencesAlerts
